import {ShiftEventCategory} from '@hconnect/common/types'
import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'
import {useTranslation} from 'react-i18next'

import {FILTER_VALUE_SEPARATOR, FEATURE_NAMESPACE} from '../../consts'

export const TaskCategoryFilter = <TName extends string>({
  ...props
}: Omit<FilterMultiSelectProps<ShiftEventCategory, TName>, 'options'>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options = Object.values(ShiftEventCategory).map((category) => ({
    value: category,
    label: t(`shiftEvent.category.${category}`)
  }))

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      renderValue={(value) =>
        value.map((category) => t(`shiftEvent.category.${category}`)).join(FILTER_VALUE_SEPARATOR)
      }
    />
  )
}
